import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import { margins } from '@/common/spacing'

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${margins.s};
`

const CurrentFlowDetails = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 18px;
  justify-content: center;
  min-width: 200px;
`

const FlowTitle = styled.strong`
  font-weight: 700;
  font-size: 14px;
`

const FlowStage = styled.span`
  font-weight: 400;
  font-size: 10px;
`

export interface FlowDetailsProps {
  currentFlowName: string
  currentFlowStage: string
  currentFlowIcon: string
}

export const FlowDetails = ({
  currentFlowName,
  currentFlowStage,
  currentFlowIcon,
}: FlowDetailsProps) => (
  <Wrapper>
    <FontAwesomeIcon icon={currentFlowIcon as IconProp} size="xl" color="#FFFFFF" />
    <CurrentFlowDetails>
      <FlowTitle>{currentFlowName}</FlowTitle>
      <FlowStage>{currentFlowStage}</FlowStage>
    </CurrentFlowDetails>
  </Wrapper>
)
